/* tslint:disable */
/* eslint-disable */
/**
 * HCL Commerce Services - Account and Contract
 * These services provide APIs to manage accounts and contracts.  a contract is an agreement that represents the terms and conditions that apply to a transaction. An account is a relationship between the merchant and the financial institution that processes transactions for that merchant.
 *
 * The version of the OpenAPI document: 9.1.6
 * 
 * (C) Copyright HCL Technologies Limited 2021
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../../../../../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../../../../../base';
// @ts-ignore
import { DeliveryRequest } from '../../../../../com/hcl/commerce/typescript/axios';
// @ts-ignore
import { DeliveryResponse } from '../../../../../com/hcl/commerce/typescript/axios';
/**
 * DeliveryDateApi - axios parameter creator
 * @export
 */
export const DeliveryDateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get Delivery Date
         * @summary Get Delivery Date
         * @param {string} storeId The store identifier.
         * @param {DeliveryRequest} deliveryRequest The request object for project creation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveryDate: async (storeId: string, deliveryRequest: DeliveryRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('deliveryDate', 'storeId', storeId)
            // verify required parameter 'deliveryRequest' is not null or undefined
            assertParamExists('deliveryDate', 'deliveryRequest', deliveryRequest)
            const localVarPath = `/store/{storeId}/NearestShop/getDeliveryDate`
                .replace(`{${"storeId"}}`, String(storeId));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deliveryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DeliveryDateApi - functional programming interface
 * @export
 */
export const DeliveryDateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DeliveryDateApiAxiosParamCreator(configuration)
    return {
        /**
         * Get Delivery Date
         * @summary Get Delivery Date
         * @param {string} storeId The store identifier.
         * @param {DeliveryRequest} deliveryRequest The request object for project creation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deliveryDate(storeId: string, deliveryRequest: DeliveryRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeliveryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deliveryDate(storeId, deliveryRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DeliveryDateApi - factory interface
 * @export
 */
export const DeliveryDateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DeliveryDateApiFp(configuration)
    return {
        /**
         * Get Delivery Date
         * @summary Get Delivery Date
         * @param {string} storeId The store identifier.
         * @param {DeliveryRequest} deliveryRequest The request object for project creation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deliveryDate(storeId: string, deliveryRequest: DeliveryRequest, options?: any): AxiosPromise<DeliveryResponse> {
            return localVarFp.deliveryDate(storeId, deliveryRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DeliveryDateApi - object-oriented interface
 * @export
 * @class DeliveryDateApi
 * @extends {BaseAPI}
 */
export class DeliveryDateApi extends BaseAPI {
    /**
     * Get Delivery Date
     * @summary Get Delivery Date
     * @param {string} storeId The store identifier.
     * @param {DeliveryRequest} deliveryRequest The request object for project creation.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeliveryDateApi
     */
    public deliveryDate(storeId: string, deliveryRequest: DeliveryRequest, options?: any) {
        return DeliveryDateApiFp(this.configuration).deliveryDate(storeId, deliveryRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
